var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme'; // import { 
//   EmailFilledCircleIcon, 
//   EntityBubbleImage, 
//   FacebookFilledCircleIcon, 
//   HTML, 
//   Icon, 
//   Icons, 
//   LinkedinFilledCircleIcon, 
//   TwitterFilledCircleIcon, 
//   classNames, 
//   useComponentColor, 
//   useCopyToClipboard, 
//   useEntity, 
//   useLang, 
//   useLink, 
//   useSite, 
//   useSiteMetadata
// } from '@shapeable/web';

import { EmailFilledCircleIcon } from './email-filled-circle-icon';
import { EntityBubbleImage } from '../entities/entity-bubble-image';
import { FacebookFilledCircleIcon } from './facebook-filled-circle-icon';
import { HTML } from './html';
import { Icon } from './icon';
import { Icons } from '../icons';
import { LinkedinFilledCircleIcon } from './linkedin-filled-circle-icon';
import { TwitterFilledCircleIcon } from './twitter-filled-circle-icon';
import { classNames } from '../../utils/cn';
import { useComponentColor } from '../../hooks/use-component-color';
import { useCopyToClipboard } from '../../hooks/use-copy-to-clipboard';
import { useEntity } from '../../hooks/use-entity';
import { useLang } from '../../hooks/use-lang';
import { useLink } from '../../hooks/use-link';
import { useSite } from '../../hooks/use-site';
import { useSiteMetadata } from '../../hooks/use-site-metadata';
var cls = classNames('lang-menu-item');
import { sprintf } from 'sprintf-js';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
export var ShareMenuItemDefaultProps = {
  iconSize: 32
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n  "], ["\n    font-size: 1em;\n    cursor: pointer;\n    display: flex;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n    padding: ", " ", ";\n\n    button, a {\n      text-decoration: none;\n      display: flex;\n      align-items: center;\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: none;\n    padding: ", " ", ";\n\n    button, a {\n      text-decoration: none;\n      display: flex;\n      align-items: center;\n    }\n\n    ", "\n  "])), theme.UNIT(2), theme.UNIT(4), function (_a) {
    var _color = _a._color,
        _boldColor = _a._boldColor,
        _hoverColor = _a._hoverColor,
        _hoverBackgroundColor = _a._hoverBackgroundColor,
        _activeColor = _a._activeColor;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n      color: ", ";\n\n      b {\n        color: ", "; \n      }\n\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n        ", ";\n\n        b {\n          color: ", ";\n        }\n      }\n\n      button, a {\n        cursor: pointer;\n        font-size: 1em;\n        font-family: ", ";\n        ", ";\n        color: ", " !important;\n\n        b {\n          color: ", "; \n        }\n\n        &:hover {\n          color: ", " !important;\n          background-color: ", ";\n          ", ";\n\n          b {\n            color: ", ";\n          }\n        }\n      }\n    "], ["\n      ", ";\n      color: ", ";\n\n      b {\n        color: ", "; \n      }\n\n      &:hover {\n        color: ", ";\n        background-color: ", ";\n        ", ";\n\n        b {\n          color: ", ";\n        }\n      }\n\n      button, a {\n        cursor: pointer;\n        font-size: 1em;\n        font-family: ", ";\n        ", ";\n        color: ", " !important;\n\n        b {\n          color: ", "; \n        }\n\n        &:hover {\n          color: ", " !important;\n          background-color: ", ";\n          ", ";\n\n          b {\n            color: ", ";\n          }\n        }\n      }\n    "])), theme.FILL(_color), _color, _boldColor, _hoverColor, _hoverBackgroundColor, theme.FILL(_hoverColor), _hoverColor, theme.FONT('sans'), theme.FILL(_color), _color, _boldColor, _hoverColor, _hoverBackgroundColor, theme.FILL(_hoverColor), _hoverColor);
  })
});
var EmailLinkStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var LabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["  \n    color: inherit;\n    font-weight: 400;\n    text-transform: inherit;\n    white-space: nowrap;\n  "], ["  \n    color: inherit;\n    font-weight: 400;\n    text-transform: inherit;\n    white-space: nowrap;\n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var FacebookIconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TwitterIconStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkedinIconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EmailIconStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.REMOVE_BUTTON_STYLE())
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubble: styled(EntityBubbleImage)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  FacebookIcon: styled(FacebookFilledCircleIcon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), FacebookIconStyles),
  TwitterIcon: styled(TwitterFilledCircleIcon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TwitterIconStyles),
  LinkedinIcon: styled(LinkedinFilledCircleIcon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LinkedinIconStyles),
  EmailIcon: styled(EmailFilledCircleIcon)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), EmailIconStyles),
  Button: styled.button(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  EmailLink: styled.a(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), EmailLinkStyles),
  Body: styled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var ShareMenuItem = function ShareMenuItem(props) {
  var className = props.className,
      children = props.children,
      onClick = props.onClick,
      iconSize = props.iconSize,
      type = props.type,
      isInverted = props.isInverted;
  var Link = useLink().Link;
  var siteMetadata = useSiteMetadata();
  var title = siteMetadata.title,
      titleTemplate = siteMetadata.titleTemplate;
  var site = useSite();
  var entity = useEntity();
  var subject = titleTemplate && entity.name ? sprintf(titleTemplate, entity.name, site.name) : title;
  var emailUrl = "mailto:?subject=" + subject + "&body=" + site.url;
  var currentUrl = '';

  if (typeof window !== 'undefined') {
    currentUrl = window.location.href;
  }

  var _a = __read(useCopyToClipboard(site.url), 2),
      siteCopied = _a[0],
      copySite = _a[1];

  var _b = __read(useCopyToClipboard(currentUrl), 2),
      pageCopied = _b[0],
      copyPage = _b[1];

  var _c = __read(React.useState(false), 2),
      pageTick = _c[0],
      setPageTick = _c[1];

  var _d = __read(React.useState(false), 2),
      siteTick = _d[0],
      setSiteTick = _d[1];

  var onSiteCopyClick = function onSiteCopyClick(e) {
    e.preventDefault();
    copySite();
    setSiteTick(true);
    setTimeout(function () {
      setSiteTick(false);
      onClick(e);
    }, 500);
  };

  var onPageCopyClick = function onPageCopyClick(e) {
    e.preventDefault();
    copyPage();
    setPageTick(true);
    setTimeout(function () {
      setPageTick(false);
      onClick(e);
    }, 500);
  };

  var t = useLang();
  var color = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.color,
    sub: 'link',
    fallbacks: ['link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link', 'light']
  });
  var boldColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.color,
    sub: 'bold',
    fallbacks: ['mid-brand', 'primary'],
    invertedFallbacks: ['light-brand', 'primary']
  });
  var hoverColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.hoverColor,
    sub: 'link-hover',
    fallbacks: ['menu-hover', 'link-hover', 'dark-brand', 'dark', 'primary'],
    invertedFallbacks: ['inverted-menu-hover', 'inverted-link-hover', 'light']
  });
  var hoverBackgroundColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.hoverBackgroundColor,
    sub: 'link-hover-background',
    fallbacks: ['menu-hover-background', 'light-brand', '#EEEEEE'],
    invertedFallbacks: ['inverted-menu-hover-background', 'mid-brand', '#666']
  });
  var activeColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: props.activeColor,
    sub: 'link-active',
    fallbacks: ['menu-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-menu-active', 'inverted-link', 'mid-brand', 'primary']
  });
  var labels = {
    "copy-site": "Copy <b>Website Link</b>",
    "copy-page": "Copy <b>Page Link</b>",
    "facebook": "Share Page on <b>Facebook</b>",
    "twitter": "Share Page on <b>Twitter</b>",
    "linkedin": "Share Page on <b>LinkedIn</b>",
    "email": "Share Page via <b>Email</b>"
  };
  var label = React.createElement(My.Label, null, React.createElement(HTML, {
    text: t(labels[type])
  }));
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, {
    _boldColor: boldColor,
    _color: color,
    _hoverColor: hoverColor,
    _activeColor: activeColor,
    _hoverBackgroundColor: hoverBackgroundColor
  }, type === "copy-site" && React.createElement(My.Button, {
    onClick: onSiteCopyClick
  }, siteTick ? React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icons.TickCircle, null)) : React.createElement(My.Bubble, {
    size: iconSize - 2,
    entity: site
  }), label), type === "copy-page" && React.createElement(My.Button, {
    onClick: onPageCopyClick
  }, pageTick ? React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icons.TickCircle, null)) : React.createElement(My.Bubble, {
    size: iconSize - 2,
    entity: entity
  }), label), type === "facebook" && React.createElement(FacebookShareButton, {
    onClick: onClick,
    url: currentUrl
  }, React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(My.FacebookIcon, null)), label), type === "twitter" && React.createElement(TwitterShareButton, {
    onClick: onClick,
    url: currentUrl
  }, React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(My.TwitterIcon, null)), label), type === "linkedin" && React.createElement(LinkedinShareButton, {
    onClick: onClick,
    url: currentUrl
  }, React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(My.LinkedinIcon, null)), label), type === "email" && React.createElement(My.EmailLink, {
    onClick: onClick,
    href: emailUrl
  }, React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(My.EmailIcon, null)), label)));
};
ShareMenuItem.cls = cls;
ShareMenuItem.defaultProps = ShareMenuItemDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;